export const createOrderItemsDisplayList = (data) =>
	data.order_items.map((item) => item.product_variant).join(', ');
